<form *ngIf="fields && form" [formGroup]="form" (ngSubmit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}" RestrictFocus>

  <div class="ui-g ui-fluid">

    <div class="ui-g-12 ui-md-12">

      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.calendar_item_id.nullable }">{{ fields.calendar_item_id.keyName }}</label>
      </div>
      <p-dropdown [options]="calendarItems" [style]="{'width':'100%'}" [filter]="true" formControlName="calendar_item_id"></p-dropdown>
      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.calendar_item_id"></app-validation-msg>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <br />
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ ('common.add' | translate) }}">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/form-calendar-group/form-calendar-group-item.html